import AvatarPicker from "./AvatarPicker";

export default AvatarPicker;
